import { render, staticRenderFns } from "./release.vue?vue&type=template&id=5eafb954&scoped=true"
import script from "./release.vue?vue&type=script&lang=js"
export * from "./release.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eafb954",
  null
  
)

export default component.exports